import { useEffect } from 'react';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  articlePublishedTime,
  articleModifiedTime,
}: SEOMetaProps) {
  useEffect(() => {
    const updateMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el && attr === 'property') {
        el = document.createElement('meta');
        el.setAttribute('property', selector.replace('meta[property="', '').replace('"]', ''));
        document.head.appendChild(el);
      } else if (!el && attr === 'name') {
        el = document.createElement('meta');
        el.setAttribute('name', selector.replace('meta[name="', '').replace('"]', ''));
        document.head.appendChild(el);
      }
      if (el) {
        el.setAttribute('content', value);
      }
    };

    document.title = title;
    updateMeta('meta[name="description"]', 'name', description);
    updateMeta('meta[name="keywords"]', 'name', keywords);
    updateMeta('link[rel="canonical"]', 'rel', canonicalUrl);
    updateMeta('meta[property="og:title"]', 'property', ogTitle || title);
    updateMeta('meta[property="og:description"]', 'property', ogDescription || description);
    updateMeta('meta[property="og:url"]', 'property', canonicalUrl);
    updateMeta('meta[property="og:type"]', 'property', ogType);
    updateMeta('meta[name="twitter:title"]', 'name', ogTitle || title);
    updateMeta('meta[name="twitter:description"]', 'name', ogDescription || description);

    if (ogImage) {
      updateMeta('meta[property="og:image"]', 'property', ogImage);
      updateMeta('meta[name="twitter:image"]', 'name', ogImage);
    }

    if (articlePublishedTime) {
      updateMeta('meta[property="article:published_time"]', 'property', articlePublishedTime);
    }
    if (articleModifiedTime) {
      updateMeta('meta[property="article:modified_time"]', 'property', articleModifiedTime);
    }

    const canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalEl) {
      canonicalEl.setAttribute('href', canonicalUrl);
    } else {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', canonicalUrl);
      document.head.appendChild(link);
    }

    const lastModEl = document.querySelector('meta[name="Last-modified"]') as HTMLMetaElement | null;
    if (!lastModEl) {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'Last-modified');
      meta.setAttribute('content', new Date().toISOString().split('T')[0]);
      document.head.appendChild(meta);
    }

    return () => {
      document.title = '奇优影院 | 免费在线观看电影电视剧全集高清 - 奇优影院不收费免费版';
      updateMeta('meta[name="description"]', 'name', '奇优影院是免费在线观看平台，提供奇优影院免费版、不收费的影视资源。最新电影电视剧大全高清播放，无需付费即可畅享海量内容。奇优影院免费观看，高清不缓冲，尽在奇优影院在线看。');
      updateMeta('meta[name="keywords"]', 'name', '奇优影院,奇优影院免费,奇优影院免费观看,奇优影院在线看,奇优影院不收费,奇优影院免费版,免费电影在线观看,免费电视剧全集,高清不缓冲');
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogImage, ogType, articlePublishedTime, articleModifiedTime]);

  return null;
}